
const LayoutHeaderFooter = resolve => require(['@/components/common/site/LayoutHeaderFooter.vue'],resolve)
const Index = resolve => require(['@/components/home/Index.vue'],resolve)

// ========== 公司业务
const BusinessRouter = resolve => require(['@/components/business/BusinessRouter.vue'],resolve)
const BusinessZhjy = resolve => require(['@/components/business/Zhjy.vue'],resolve)
const BusinessSzyd = resolve => require(['@/components/business/Szyd.vue'],resolve)
const BusinessSzcb = resolve => require(['@/components/business/Szcb.vue'],resolve)
const BusinessSepx = resolve => require(['@/components/business/Sepx.vue'],resolve)
const BusinessHwyw = resolve => require(['@/components/business/Hwyw.vue'],resolve)

// ========== 解决方案
const SolutionRouter = resolve => require(['@/components/solution/SolutionRouter.vue'],resolve)
const SolutionForclass = resolve => require(['@/components/solution/Forclass.vue'],resolve)
const SolutionSw = resolve => require(['@/components/solution/Sw.vue'],resolve)
const SolutionYjsf = resolve => require(['@/components/solution/Yjsf.vue'],resolve)
const SolutionKcsj = resolve => require(['@/components/solution/Kcsj.vue'], resolve)
const SolutionDykc = resolve => require(['@/components/solution/Dykc.vue'],resolve)
const SolutionRjky = resolve => require(['@/components/solution/Rjky.vue'],resolve)
const SolutionXPS = resolve => require(['@/components/solution/XPS.vue'],resolve)


// ========== 公司动态
const News = resolve => require(['@/components/news/Qbdt.vue'],resolve)
const NewDetail = resolve => require(['@/components/news/NewDetail.vue'],resolve)

// ========== 政策解读
const PolicyList = resolve => require(['@/components/policy/List.vue'],resolve)
const PolicyDetail = resolve => require(['@/components/policy/Detail.vue'],resolve)

// ========== 关于创而新
const AboutRouter = resolve => require(['@/components/about/AboutRouter.vue'],resolve)
const AboutQyjs = resolve => require(['@/components/about/Qyjs.vue'],resolve)
const AboutFzlc = resolve => require(['@/components/about/Fzlc.vue'],resolve)
const AboutJsjd = resolve => require(['@/components/about/Jsjd.vue'],resolve)
const AboutQyry = resolve => require(['@/components/about/Qyry.vue'],resolve)
const AboutZjtd = resolve => require(['@/components/about/Zjtd.vue'],resolve)
const AboutHzhb = resolve => require(['@/components/about/Hzhb.vue'],resolve)
const AboutHzhb1 = resolve => require(['@/components/about/Hzhb1.vue'],resolve)
const AboutLxwm = resolve => require(['@/components/about/Lxwm.vue'],resolve)
const AboutJrwm = resolve => require(['@/components/about/Jrwm.vue'],resolve)

//  ================   应用案例 ======
const ApplicationCaseRouter = resolve => require(['@/components/application/ApplicationCaseRouter.vue'], resolve)
const ApplicationIndex = resolve => require(['@/components/application/Index.vue'], resolve)
const ApplicationSystem = resolve => require(['@/components/application/ApplicationSystem.vue'], resolve)
const ApplicationArea = resolve => require(['@/components/application/ApplicationArea.vue'], resolve)
const ApplicationSchool = resolve => require(['@/components/application/ApplicationSchool.vue'], resolve)

const routers = [
  {
    path: '/',
    name: 'LayoutHeaderFooter',
    component: LayoutHeaderFooter,
    children: [{
      path: '/',
      name: '首页',
      component: Index,
      meta: { title: '创而新_首页' }
    }]
  },
  {
    path: '/',
    name: 'LayoutHeaderFooter',
    component: LayoutHeaderFooter,
    children: [{
      path: '/',
      name: '服务支持',
      component: BusinessRouter,
      children: [{
        path: '/Business/Zhjy',
        name: '智慧教育',
        component: BusinessZhjy,
        meta: { parentName: '服务支持',title: '创而新_公司业务_智慧教育'}
      },{
        path: '/Business/Szyd',
        name: '数字阅读',
        component: BusinessSzyd,
        meta: { parentName: '解决方案',title: '创而新_公司业务_数字阅读' }
      },{
          path: '/Business/Szcb',
          name: '数字出版',
          component: BusinessSzcb,
          meta: { parentName: '服务支持',title: '创而新_公司业务_数字出版'}
      },{
        path: '/Business/Sepx',
        name: '少儿培训',
        component: BusinessSepx,
        meta: { parentName: '解决方案',title: '创而新_公司业务_少儿英语'}
      },{
        path: '/Business/Hwyw',
        name: '海外业务',
        component: BusinessHwyw,
        meta: { parentName: '服务支持',title: '创而新_公司业务_海外业务'}
      }]
    }]
  },
  {
    path: '/',
    name: 'LayoutHeaderFooter',
    component: LayoutHeaderFooter,
    children: [{
      path: '/',
      name: '应用案例',
      component: ApplicationCaseRouter,
      children: [{
        path: '/Application/Index',
        name: '应用案例首页',
        component: ApplicationIndex,
        meta: { parentName: '应用案例',title: '创而新_应用案例'}
      },{
        path: '/Application/SystemCase',
        name: '教育集团信息化建设案例',
        component: ApplicationSystem,
          meta: { parentName: '应用案例', title: '创而新_公司业务_教育集团信息化建设案例' }
      },{
          path: '/Application/AreaCase',
          name: '区域整体教育信息化建设案例',
          component: ApplicationArea,
          meta: { parentName: '应用案例', title: '创而新_公司业务_区域整体教育信息化建设案例'}
      },{
        path: '/Application/SchoolCase',
        name: '学校信息化建设案例',
        component: ApplicationSchool,
        meta: { parentName: '应用案例',title: '创而新_公司业务_学校信息化建设案例'}
      }]
    }]
  },

  {
    path: '/',
    name: 'LayoutHeaderFooter',
    component: LayoutHeaderFooter,
    children: [{
      path: '/',
      name: '解决方案',
      component: SolutionRouter,
      children: [{
        path: '/Solution/ForClass',
        name: 'ForClass',
        component: SolutionForclass,
        meta: { parentName: '解决方案',title: '创而新_解决方案_Forclass'}
      },{
        path: '/Solution/Sw',
        name: 'Sw',
        component: SolutionSw,
        meta: { parentName: '解决方案',title: '创而新_解决方案_SW软件'}
      },{
        path: '/Solution/Yjsf',
        name: '悦教书法',
        component: SolutionYjsf,
        meta: { parentName: '解决方案',title: '创而新-解决方案-书法课程'}
      },{
        path: '/Solution/Kcsj',
        name: '课程设计',
        component: SolutionKcsj,
        meta: { parentName: '解决方案',title: '创而新-解决方案-课程设计'}
      },{
        path: '/Solution/Dykc',
        name: '打印课程',
        component: SolutionDykc,
        meta: { parentName: '解决方案',title: '创而新-解决方案-打印课程'}
      },{
        path: '/Solution/Rjky',
        name: '人教口语',
        component: SolutionRjky,
        meta: { parentName: '解决方案',title: '创而新-特色课程-口语课程'}
        }, {
          path: '/Solution/Xps',
          name: 'XPS',
          component: SolutionXPS,
          meta: { parentName: '解决方案', title: '创而新-解决方案-xps' }
        }]
    }]
  },

  {
    path: '/',
    name: 'LayoutHeaderFooter',
    component: LayoutHeaderFooter,
    children: [{
      path: '/News/Qbdt',
      name: '公司动态',
      component: News,
      meta: { parentName: '动态头条', title: '创而新_公司动态_全部动态' }
    },{
      path: '/News/NewDetail',
      name: '新闻详情',
      component: NewDetail,
      meta: { parentName: '动态头条', title: '创而新_公司动态_企业动态' }
    }]
  },

  {
    path: '/',
    name: 'LayoutHeaderFooter',
    component: LayoutHeaderFooter,
    children: [{
      path: '/Policy/List',
      name: '时事政策',
      component: PolicyList,
      meta: { parentName: '政策解读', title: '创而新_公司动态_政策解读' }
    },{
      path: '/Policy/Detail',
      name: '政策详情',
      component: PolicyDetail,
      meta: { parentName: '政策解读', title: '创而新_公司动态_政策详情' }
    }]
  },
  {
    path: '/',
    name: 'LayoutHeaderFooter',
    component: LayoutHeaderFooter,
    children: [{
      path: '/',
      name: '关于创而新',
      component: AboutRouter,
      children: [{
        path: '/About/Qyjs',
        name: '企业简介',
        component: AboutQyjs,
        meta: { parentName: '关于创而新', title: '创而新_关于创而新_企业简介' }
      },{
        path: '/About/Fzlc',
        name: '发展历程',
        component: AboutFzlc,
        meta: { parentName: '关于创而新', title: '创而新_关于创而新_发展历程' }
      },{
        path: '/About/Jsjd',
        name: '技术积淀',
        component: AboutJsjd,
        meta: { parentName: '关于创而新', title: '创而新_关于创而新_技术积淀' }
      },{
        path: '/About/Qyry',
        name: '企业荣誉',
        component: AboutQyry,
        meta: { parentName: '关于创而新', title: '创而新_关于创而新_企业荣誉' }
      },{
        path: '/About/Zjtd',
        name: '专家团队',
        component: AboutZjtd,
        meta: { parentName: '关于创而新', title: '创而新_关于创而新_专家团队' }
      },{
        path: '/About/Hzhb',
        name: '合作伙伴',
        component: AboutHzhb,
        meta: { parentName: '关于创而新', title: '创而新_关于创而新_合作伙伴' }
      },{
        path: '/About/Hzhb1',
        name: '合作伙伴',
        component: AboutHzhb1,
        meta: { parentName: '关于创而新', title: '创而新_关于创而新_合作伙伴1' }
      },{
        path: '/About/Lxwm',
        name: '联系我们',
        component: AboutLxwm,
        meta: { parentName: '关于创而新', title: '创而新_关于创而新_联系我们' }
      },{
        path: '/About/Jrwm',
        name: '加入我们',
        component: AboutJrwm,
        meta: { parentName: '关于创而新', title: '创而新_关于创而新_加入我们' }
      },]
    }]
  },
]
export default routers



// WEBPACK FOOTER //
// ./src/router/index.js